import { useFormContext, get } from "react-hook-form";

export const FieldError = ({ name, step }) => {
  const { formState: { errors } } = useFormContext();

  let err = get(errors, name);

  // If the resolved error is an array, prefer an exact-match message on this field,
  // otherwise fall back to the first child error with a message. This avoids showing
  // an unrelated row's message when rendering list items.
  if (Array.isArray(err)) {
    const exact = err.find((e) => e?.message);
    if (exact) err = exact;
    else {
      err = err.find((e) => Object.values(e || {}).some((x) => x?.message));
      if (err && typeof err === "object" && !err.message) {
        err = Object.values(err).find((x) => x?.message);
      }
    }
  }

  const message = err?.message;

  return message ? <p className="text-sm text-red-600">{message}</p> : null;
};
